//  全部资讯 (资讯管理)
import http from '../utils/http'
// 资讯列表
export function listInformationAPI(data, params) {
    return http.post('/information/list', data, params)
}
// 资讯详情
export function previewInformationAPI(params) {
    return http.get('/information/preview', params)
}
//  评论列表
export function showcommentlistAPI(params) {
    return http.get('/information/showcommentlist', params)
}
// 评论
export function commentlistInformationAPI(data, params) {
    return http.post('/information/commentlist', data, params)
}
// 删除评论
export function deleteInformationAPI(data, params) {
    return http.post('/information/deleteCommentlist', data, params)
}
// 资讯审核
export function auditInformationAPI(data) {
    return http.post('/information/audit', data)
}
// 删除资讯
export function deleteAPI(data, params) {
    return http.post('/information/delete', data, params)
}